import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '../core/enviroment/environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeadCampaignService {

  public baseUrl = this.envSvc.getEnvVar('api_leads');

  constructor(
    private http: HttpClient,
    private envSvc: EnvironmentService
  ) { }

  public getCampaignList(text = '') {
    return this.http.get<any>(this.baseUrl + '/campaigns?page=1&max_items=99&text=' + text);
  }

  public getParticipantsAutoComplete(name: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/campaign/participants/autocomplete?value=${name}`);
  }

  public setCampaignParticipants(campaignId, body) {
    return this.http.post<any>(`${this.baseUrl}/campaigns/${campaignId}/participants`, body);
  }

  public getCampaign(id) {
    return this.http.get<any>(`${this.baseUrl}/campaigns/${id}`);
  }

  public autocomplete(searchValue) {
    return this.http.get<any>(`${this.baseUrl}/campaign/autocomplete?search_value=${searchValue}&max_items=5`);
  }

  public realtorAlreadyParticipating(campaignId, realtorId) {
    return this.http.get<any>(`${this.baseUrl}/campaign/${campaignId}/participants/${realtorId}/exists`);
  }

  public getSubscription(campaignId: string) {
    return this.http.get<any>(`${this.baseUrl}/campaigns/${campaignId}/participants`);
  }

  public updateSubscription(campaignId: string, data: any): Observable<any> {
    return this.http.patch<any>(`${this.baseUrl}/campaigns/${campaignId}/participants`, data);
  }

  public generateBillet(campaignId: string, subscriptionId: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/subscription/${campaignId}/payment?subscription_id=${subscriptionId}`, null);
  }

  public getBillet(subscriptionId: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/subscription/payment?subscription_id=${subscriptionId}`);
  }

  /**
   * It will parse the string number into the currency format.
   * @param value String value (e.g '1.350,32').
   * @returns If valid string will return a parsed number (e.g 1350.32) or null if not valid.
   */
   public parseCurrency(value: string): number {
    try {
      if (typeof value === 'number') return value;
      if (value === '') return 0;
      return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    } catch (error) {
      return null;
    }
  }

  /**
   * @param total 
   * @param portion 
   * @returns the percentage of the portion from the total.
   */
  public getPercentage(total: number, portion: number): number {
    return Number(((portion * 100) / total));
  }
}